var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8536 1.14648C14.7842 1.07696 14.6958 1.02945 14.5994 1.00989C14.5031 0.990322 14.4032 0.999573 14.3121 1.03648L1.23062 6.33998C1.14303 6.37496 1.06711 6.43399 1.01164 6.51027C0.956163 6.58656 0.923397 6.67697 0.917123 6.77108C0.910849 6.86519 0.931322 6.95916 0.976179 7.04213C1.02103 7.1251 1.08844 7.19369 1.17062 7.23998L5.55012 9.74098L8.84362 6.44998C8.93856 6.36261 9.06359 6.31531 9.19259 6.31798C9.32158 6.32066 9.44455 6.37309 9.53578 6.46432C9.62702 6.55556 9.67945 6.67852 9.68212 6.80752C9.6848 6.93651 9.6375 7.06155 9.55012 7.15648L6.25862 10.45L8.76262 14.831C8.80663 14.9072 8.86999 14.9705 8.94628 15.0144C9.02257 15.0583 9.1091 15.0812 9.19712 15.081H9.23062C9.32417 15.0746 9.41405 15.0421 9.49 14.9871C9.56594 14.9321 9.6249 14.8569 9.66012 14.77L14.9636 1.68748C15.0004 1.59647 15.0096 1.49663 14.9901 1.40042C14.9705 1.30422 14.923 1.2159 14.8536 1.14648Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/Sent.1e289cf0596b483712a12ff58f530bcd.svg";
export { ForwardRef as ReactComponent };